export const ACTIVE = 'ACTIVE'
export const CRM_DEACTIVATED = 'CRM_DEACTIVATED'
export const INACTIVE = 'INACTIVE'
